export default "__VITE_ASSET__012ae366__"